$(document).ready(function(){
    
    //INSCRIPTION A LA NEWSLETTER DEPUIS LE FOOTER

    $(".formNewsletter").submit(function(){
        
        //On recupere les données du formulaire
        var email = $(this).find('input[name="emailNewsletter"]').val();
        var rgpd = $(this).find('input[name="checkRGPDnewsletter"]').val();
        var checkRgpd = $(this).find('input[name="checkRGPDnewsletter"]').prop("checked");
        //On masque les eventuels message d'erreur / succes
        $(this).find(".message-newsletter").remove();

        //Si les données sont bien renseigné"s
        if(email && checkRgpd){            

            //On prépare la requette ajax
            var request = $.ajax({
                url: "/controller/reico/newsletter",
                method: "POST",
                data: { 
                    email : email,
                    checkrgpd : rgpd,
                },
            });
            
            //Si la requette est bien exécutée
            request.done(function( msg ) {

                //On récupere les données retournées par le controlleur et on les décode
                if(msg){
                    msg = JSON.parse(msg);
                    console.log(msg);
                    //Si erreur
                    if(msg.erreur){
                        $( ".formNewsletter" ).prepend("<div class='mt-4 message-newsletter'><div class='alert alert-danger'>"+msg.erreur+"</div></div>");
                    }

                    //Si succes
                    if(msg.succes){
                        $( ".formNewsletter" ).prepend("<div class='mt-4 message-newsletter'><div class='alert alert-success'>"+msg.succes+"</div></div>");

                        //On vide les champs
                        $(this).find('input[name="email"]').val('')
                        $(this).find('input[name="footerNewsletterRGPD"]').prop( "checked", false );

                    }
                }
            });
        
            //Si erreur
            request.fail(function( jqXHR, textStatus ) {
                //
                $( ".formNewsletter" ).prepend("<div class='mt-4 message-newsletter'><div class='alert alert-danger'>Une erreur est survenue, merci de réessayer ultérieurement</div></div>");
            });
        }else{
            //erreur champ mal renseigné
            $( ".formNewsletter" ).prepend("<div class='mt-4 message-newsletter'><div class='alert alert-danger'>Merci de renseigner correctement les champs du formulaire</div></div>");
        }

        return false;
    });
});